export const PROVIDERS_LIST_LENGTH = 5;
